export const initGTM = () => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  };
  
  export const triggerGTMEvent = (eventName, eventData = {}) => {
    if (!window.dataLayer) return;
  
    const payload = {
      event: eventName,
      ...eventData,
    };
  
    console.log("[GTM Event Triggered]:", payload);
    console.log("Current Data Layer:", window.dataLayer);

    window.dataLayer.push(payload);
  };